import {Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {LngKeys} from '@app/common/enums/lng-keys';
import {Language} from '@app/common/interfaces/route-paths';
import {LANGUAGES_OBJ} from '@app/common/constants/languages_data';
import {AppStateService} from '@app/common/services/app-state.service';
import {redirectToTranslatedPath} from '@app/common/helpers/url-helpers';
import {DropdownComponent} from '@app/common/ui-kits/dropdown/dropdown.component';
import {ChangeDetectionStrategy, Component, inject, OnInit, Renderer2} from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    TranslatePipe,
    DropdownComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
  private readonly router = inject(Router);
  public readonly renderer = inject(Renderer2);
  protected readonly appStateService = inject(AppStateService);

  constructor() {
  }

  ngOnInit() {
  }

  protected changeLanguage(event: Language): void {
    this.appStateService.setLng(event.key);
    this.appStateService.setHtmlLangAttribute(event.key, this.renderer);
    this.appStateService.addMetaTags(LANGUAGES_OBJ[event.key as LngKeys].seo);

    redirectToTranslatedPath(this.router, event.key);
  }

}
